
import Component from 'vue-class-component'
import { Watch } from "vue-property-decorator"
import moduleStore from './store/textGenerate';
import Vue from 'vue';
import PageState from './store/state';
import LZString from '../../utils/lz-string.min'
import { toast } from '@/utils/util'
import { Toast, Dialog } from 'vant';
import { copy } from '@/utils/util'
import { judgeDeviceType } from "@/utils/device";
import { getQueryString } from "@/utils/location";
import { FUN_DATA } from "@/constants/generateType";
import memberDialog from "@/components/member-dialog/member-dialog.vue"
import { VIP_TYPE } from "@/constants/vip"
/**components**/
@Component({
	components: {
		memberDialog
	}
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class textGeneratePage extends Vue {
	state = new PageState();
	self: Vue = this;
	wordNum: number = 0;
	sourceText: string = "";
	maxlength: number = 5000;
	ww_token: string = getQueryString("ww_token");
    
	isAPP = judgeDeviceType.isAPP;
	isIOSWxMini = judgeDeviceType.isIOSWxMini;
	isIOS = judgeDeviceType.isIOS;
	isSubmiting: boolean = false;
	generateText: string = "开始生成";
	// actionSheetTitle: string = "请选择需要改写的风格";
	buycontentText: string = "你还不是会员，AI字数生成服务仅开放给会员使用，成为会员后可以购买字数使用。";
	//购买会员弹框
	buyMemberVisible: boolean = false;
	funcData = FUN_DATA;
	curFunId: string = '8';
	showResult: boolean = false;
	showType: boolean = false;
	showSubType: boolean = false;
	isCreating: boolean = false;
	canGenerate: boolean = true;
	messageShow: boolean = false;
	msgContent: string = '';

	articleResult: any = {};
	//购买字数
	buyWordVisible: boolean = false;
	globalLoading = null;
	stepObj: any = {
		step: -1,
		rank: 0
	};
	vipInfo: any = {};
	copyText: string = "";
	articleResultText: string = '';

	get curGenerateInfo() {
		return this.funcData.filter(item => item.id == this.curFunId.split('_')[0])[0]
	}
	get subId() {
		return parseInt(this.curFunId.split('_')[1] || '-1');
	}
	get appVersion() {
		let appV = this.$store.state.appVersion
		if (appV) {
			return parseInt(appV.replace(/\./g, ''))
		} else {
			return 0
		}
	}
	created(moduleData: IinjectDatas) {
		// this.vipPermission = this.vipInfo.types
		this.state = <PageState>moduleData.state;
        let wwid = getQueryString("wwid");
		if (this.ww_token) {
			this.getCurVipInfo();
		}
        if(wwid){
            localStorage.setItem('wwid',wwid)
        }
		if (this.$route.query.text) {
			this.sourceText = decodeURIComponent(this.$route.query.text as string)

		} else {
			let text = localStorage.getItem('articleContent')
			text && (this.sourceText = localStorage.getItem('articleContent'));
			localStorage.removeItem('articleContent')
		}

	}
	getAppClipBordContent(copyText: string) {
		copyText = decodeURIComponent(copyText)
		if (copyText) {
			this.sourceText = copyText;
		}
	}

	mounted() {
		let wordTextareaRef = this.$refs.wordTextarea as HTMLTextAreaElement;
		wordTextareaRef.addEventListener('paste', (e) => {
			// window.collectEvent('words_start', pointData)
            let wwid = localStorage.getItem('wwid');
			if (wwid) {
                wwid = this.vipInfo.wwid;
                localStorage.setItem('wwid',wwid);
            }
			window.collectEvent('tools_aiarticle_write', {
				'button': '粘贴',
                "user_id":wwid
			})
			let clipboardDataText = (e.clipboardData || window.clipboardData).getData('text');
			let text = clipboardDataText.replace(/[^\p{L}\p{N}\s]/gu, '').replace(/\s/g, '');
			if (this.getFilterWordLen < 5000) {
				if (this.isIOS) {
					this.maxlength = this.getPasteLimit(clipboardDataText, 5000 - this.getFilterWordLen) + this.sourceText.length + this.countNewlines(this.sourceText) || 5000;

				} else {
					this.maxlength = this.getPasteLimit(clipboardDataText, 5000 - this.getFilterWordLen) + this.sourceText.length || 5000;
				}

			}

			if (text.length + this.getFilterWordLen > 5000) {

				return toast("文案最多输入5000字", 'top')
			}
		});
		(window as any).getAppClipBordContent = this.getAppClipBordContent;
	}

	@Watch("$route")
	watchRouteParamChange() {
		if (this.$route.query.copyText) {
			this.copyText = LZString.decompressFromBase64(this.$route.query.copyText as string);
		}
		this.state.title = "文案生成"
		document.title = "文案生成"
		this.getCurVipInfo();

	}
	getCurVipInfo() {
		return new Promise((resolve, reject) => {
			this.$http("getvipInfo", {
				origin: 'voice-maker-h5'
			}).then((res) => {
				if (res.code == 200) {
					this.vipInfo = res.data
					this.wordNum = res.data?.wordNum || 0;
					if (!this.vipInfo.aiCapacity) {
						this.funcData = FUN_DATA.filter((item) => {
							return !item.limit
						})
						this.curFunId = '2'
					}
					resolve(res.data)
				} else {
					reject(res)
					toast(res.message);
				}
			}).catch((err) => {
				reject(err)
			})
		})
	}

	/**
	 * Counts the number of newlines in a given string.
	 *
	 * @param {string} str - The input string to count newlines from.
	 * @return {number} The number of newlines in the input string.
	 */
	countNewlines(str: string): number {
		// 使用正则表达式匹配换行符，并返回匹配结果的数量
		return (str.match(/\n/g) || []).length;
	}
	/**
	 * 
	 *
	 * @param {string} text - The input string to calculate the limit for.
	 * @param {number} num - 限制无符号和空格计算的字数，
	 * @return {number} 带有符号的字数
	 */
	getPasteLimit(text: string, num: number): number {
		let len = 0;
		let realLen = 0
		for (let i = 0; i < text.length; i++) {
			len++;
			//非标点符号或空字符则realLen++
			if (!/[^\p{L}\p{N}\s]/gu.test(text[i]) && !/\s/gu.test(text[i])) {
				realLen++;
			}
			//ios空字符计算算两个（iosbug所致），
			if (realLen >= num) {
				return len
			}
		}
	}
	//动态计算字符，去除标点符号不能超过5000字
	textInput() {
		let stxtLen = this.sourceText.length
		let maxlength = 5000 + (stxtLen - this.getFilterWordLen) || 5000
		if (this.isIOS) {
			this.maxlength = maxlength + this.countNewlines(this.sourceText)
		} else {
			this.maxlength = maxlength
		}

	}
	pasteUrl() {
		// window.collectEvent('words_start', pointData)
        let wwid = localStorage.getItem('wwid');
		if (wwid) {
          wwid = this.vipInfo.wwid;
          localStorage.setItem('wwid',wwid);
        }
		window.collectEvent('tools_aiarticle_write', {
			'button': '粘贴',
            "user_id":wwid
		})
		if (this.isSubmiting) {
			return toast("正在生成中，请稍后再试")
		}
		if (this.isAPP) {
			let getClipBordContent: any = (<any>window).getClipBordContent
			//let param:string=JSON.stringify({'articleId':this.state.articleId,'audioLink':this.state.audioOssFile,'videoName':this.editor.textContent.slice(0,11)})
			getClipBordContent.postMessage("")
		} else {
			toast("请点击输入框，长按粘贴内容")
		}
	}
	/**
	 * 获取无各国特殊字符的长度.
	 *`\p{L}` 可以匹配任何字母字符，`\p{N}` 可以匹配任何数字字符，`\s` 可以匹配空白字符。 `u` 修饰符是用来启用 Unicode 匹配模式
	 * @return {number} The length of the filtered word.
	 */
	get getFilterWordLen() {
		const foreignPunctuation = /[^\p{L}\p{N}\s]/gu;
		const whitespace = /\s/g;
		const filterWord = this.sourceText.replace(foreignPunctuation, '').replace(whitespace, '');
		return filterWord.length;
	}
	clearUrl() {
		if (!this.isSubmiting) {
			this.sourceText = "";
		} else {
			toast("正在生成中，请稍后再试")
		}
	}
	selectType(item, type: number) {
		if (type == 0 && item.subInfos) {
			this.curFunId = item.id + '_' + 0;
		} else {
			this.curFunId = item.id
		}
		this.showType = false;
		this.showSubType = false;
	}
	gotoLogin() {
		let path = encodeURIComponent(`/pages/webview/webview?url=${location.href}&nav=${'一键生成'}`)
		this.$navigateTo({ url: `/pages/login/login?redirect=${path}` })
	}
	//购买字数
	goToBuyWord() {
		if (!this.ww_token) {
			return this.gotoLogin()
		} else {
			if (this.vipInfo.type !== VIP_TYPE.SVIP) {
				this.buyWordVisible = false
				this.buyMemberVisible = true
				return
			}
		}

		if (window.platformSource == 'app') {
			if(this.appVersion < 137){
				toast("请升级到最新版本购买",'top')
				return
			  }
			let callMoyinAppPay: any = (<any>window).callMoyinAppPay
			callMoyinAppPay.postMessage("")
		} else {

			this.$navigateTo({
				url: "/mine-package/pages/buy-word/buy-word",
			})
		}


	}
	//续费会员
	goToBuyVip() {
		if (window.platformSource == 'app') {
			let switchToVipPage: any = (<any>window).switchToVipPage
			switchToVipPage.postMessage("")
		} else {
			this.$navigateTo({
				url: `/pages/recharge-vip/recharge-vip?fromBtn=textGenerate`,
			})
		}

	}
	cancelBuy() {
		this.buyMemberVisible = false
	}
	initState() {
		this.isCreating = false
		this.canGenerate = true
		this.isSubmiting = false
		this.generateText = '开始生成'
		this.stepObj = {
			step: -1,
			rank: 0
		};

	}
	async startGenerate() {
		if (!this.getFilterWordLen) {
			return toast("请输入你的原始文案", 'top')

		}
		if(localStorage.getItem('platform') == 'tt'){
			let res2 = await this.$http('checkContent',{ 
				body:{
				  "content":this.sourceText
				}
			});
			if(res2.err_code==-1){//抖音校验内容失败
			  toast(`${res2.err_msg}`, 'top');
			}
			if(res2.data.predicts[0].hit){//违规
			  toast('文章内容包含违规词', 'top')
			  return ;
			}
		}
		if (!this.ww_token) {
			return this.gotoLogin()
		}
		if (this.wordNum < this.getFilterWordLen) {
			this.buyWordVisible = true
			return

		}
		let Obj = this.curGenerateInfo
		let sourceParam: any = {
			prevChat: [],
			textReplace: this.sourceText,
			language: ''
		}


		if (this.subId >= 0) {
			sourceParam.destination = Obj?.subInfos[this.subId]?.text
		}
		let param: any = Obj.template(sourceParam)

		this.isCreating = true
		this.showResult = false
		this.isSubmiting = true
		// 埋点
		param.title = this.sourceText.slice(0, 15)

		this.$http("startAiGenerates", { body: param }).then((res: any) => {
			if (res.code !== 200 || !res.data) {
				this.messageShow = true
				this.msgContent = res.data?.message || res.message || '生成失败'
				this.initState()
				return
			}
			setTimeout(() => {
				this.getResult(res.data.taskId)
			}, 3000)
			// window.location.href =location.protocol+"//"+location.host+ "/#/extractResult?params="+JSON.stringify(resData)
		})
			.catch((err) => {
				toast("服务出错，请稍后再试");
				this.initState()
			})
		let text = this.subId >= 0 ? Obj.text + Obj.subInfos[this.subId].text : Obj.text
		// window.collectEvent('words_start', pointData)
        let wwid = localStorage.getItem('wwid');
		if (wwid) {
          wwid = this.vipInfo.wwid;
          localStorage.setItem('wwid',wwid);
        }
		window.collectEvent('tools_aiarticle_write', {
			'button': text,
            "user_id":wwid
		})
	}
	isCancel = false
	//取消任务
	async cancelTask(taskId) {
		try {
			await this.$http("deleteTask", { taskId });
			toast('任务已取消');
			this.initState();
		} catch (err) {
			toast('任务取消失败');
		}
	}
	//获取提取结果
	async getResult(taskId: string) {
		if (this.isCancel) {
			this.isCancel = false;
			await this.cancelTask(taskId);
			this.globalLoading.clear();
			return;
		}
		try {
			const res = await this.$http("getTaskResult", { taskId });
			const resData = res.data;

			if (resData.step == 2) {
				this.articleResult = resData
				this.articleResultText = resData.resContent.trim();
				this.initState();
				this.showResult = true;
				this.getCurVipInfo();
				this.stepObj = {
					step: 2,
					rank: 0
				};
			} else if (resData.step == 0 || resData.step === 1) {
				let step = resData.step;
				this.stepObj = {
					step: step,
					rank: resData.rank || 0
				};
				this.generateText = resData.description;
				setTimeout(() => {
					this.getResult(taskId);
				}, 3000);
			} else {
				this.initState();
				this.msgContent = res.data.message || '生成失败';
				this.messageShow = true;
				this.stepObj = {
					step: -1,
					rank: 0
				};
			}
		} catch (err) {
			this.initState();
			let errorMessage = err.message || '服务出错，请稍后再试';
			toast(errorMessage);
		}
	}

	cancelGenerate() {
		this.globalLoading = Toast.loading({
			message: '取消中...',
			forbidClick: true,
			duration: 200
		});
		this.isCancel = true;
		window.collectEvent('tools_aiarticle_lineup')
	}
	goToIndex() {
		let vm = this;
		if (vm.articleResult) {
			localStorage.setItem('articleContent', vm.articleResultText)
		}
		let resultTxt = encodeURIComponent(LZString.compressToBase64(vm.articleResultText));
		let resultObj = { 'copyText': resultTxt };
		if (this.isAPP) {
			let switchToEditPage: any = (<any>window).switchToEditPage
			switchToEditPage.postMessage(JSON.stringify(resultObj))
		} else {
			vm.$navigateTo({
				url: "/pages/audition-web/audition-web?articleContent=true",
			})
		}

	}

	copyContent() {
		if (this.isAPP) {
			let setAppClipBoardContent: any = (<any>window).setAppClipBoardContent
			setAppClipBoardContent.postMessage(this.articleResultText)

		} else {
			copy(this.articleResultText).then(() => {
				toast("内容已复制");
			});
		}

	}

}
